import { BasicButton, RadioCard, Typography } from "@/components";
import { BackAppBar } from "@/components/ui";
import { LETTER_TYPE, LETTER_TYPE_VALUE } from "@/libraries/constant";
import type { NewCaseLetterFormFieldSchema } from "@/schemas";
import { createFileRoute } from "@tanstack/react-router";
import { useFormContext } from "react-hook-form";

export const Route = createFileRoute("/dashboard/case/view/$id/letter/new/")({
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = Route.useNavigate();
	const caseId = Route.useParams({
		select: (s) => s.id,
	});
	const { register, watch } = useFormContext<NewCaseLetterFormFieldSchema>();
	const registerType = register("case_letter.letter_type");
	const letterType = watch("case_letter.letter_type");
	return (
		<>
			<BackAppBar title="Select Letter Type" />
			<div className="flex-1 bg-white py-4">
				<div className="container flex flex-col gap-4">
					<div className="flex flex-col gap-1">
						<Typography fontWeight={900} fontSize={14}>
							Select one of the letter type:
						</Typography>
						<Typography fontWeight={400} fontSize={14}>
							Choose the type of medical letter you want to create:
						</Typography>
					</div>
					<div className="flex flex-col gap-3">
						<RadioCard
							{...registerType}
							value={LETTER_TYPE.DISCHARGE_LETTER}
							checked={letterType === LETTER_TYPE.DISCHARGE_LETTER}
							title={LETTER_TYPE_VALUE[LETTER_TYPE.DISCHARGE_LETTER]}
							info="Patient discharge summary and instructions"
							inputProps={{
								name: "case_letter.letter_type",
								onChange: registerType.onChange,
								onBlur: registerType.onBlur,
							}}
						/>
						<RadioCard
							{...registerType}
							value={LETTER_TYPE.REFERRAL_LETTER}
							checked={letterType === LETTER_TYPE.REFERRAL_LETTER}
							title={LETTER_TYPE_VALUE[LETTER_TYPE.REFERRAL_LETTER]}
							info="Specialist consultation and referral request"
							inputProps={{
								name: "case_letter.letter_type",
								onChange: registerType.onChange,
								onBlur: registerType.onBlur,
							}}
						/>
						<RadioCard
							{...registerType}
							value={LETTER_TYPE.OTHER_LETTER}
							checked={letterType === LETTER_TYPE.OTHER_LETTER}
							title={LETTER_TYPE_VALUE[LETTER_TYPE.OTHER_LETTER]}
							info="Medical certificates, reports, and other correspondence"
							inputProps={{
								name: "case_letter.letter_type",
								onChange: registerType.onChange,
								onBlur: registerType.onBlur,
							}}
						/>
					</div>
				</div>
			</div>
			<div className="container bg-white py-4 shadow">
				<BasicButton
					variant="contained"
					color="secondary"
					className="!h-12 text-sm font-bold !shadow-none"
					fullWidth
					disable={!letterType}
					onClick={() =>
						navigate({
							to: "/dashboard/case/view/$id/letter/new/info",
							params: {
								id: caseId,
							},
							replace: true,
						})
					}
				>
					Next
				</BasicButton>
			</div>
		</>
	);
}
